import React from 'react';
import PropTypes from 'prop-types';

const CardFooter = ({
  left,
  right,
}) => (
  <div className="CardFooter">
    {left &&
      <div className="CardFooter__left">
        {left}
      </div>
    }
    {right &&
      <div className="CardFooter__right">
        {right}
      </div>
    }
  </div>
);

CardFooter.propTypes = {
  left: PropTypes.string,
  right: PropTypes.string,
};

CardFooter.defaultProps = {
  left: null,
  right: null,
};

export default CardFooter;
